import { useAuthStore } from "../stores/authStore";
import type {
  Permission,
  PermissionReason,
  Permissions,
} from "../models/permissions";

// Re-export for backwards compatibility
// biome-ignore lint: Preventing git push but don't won't to remove
export { useCustomerLicence } from "./useCustomerLicence";

const EMPTY_PERMISSIONS: Permissions = {};

export const usePermission = (
  name: Permission,
): PermissionReason | undefined => {
  return useAuthStore((s) => {
    if (s.status === "loading") return undefined;
    return s.session.permissions[name];
  });
};

export const usePermissions = (): Permissions => {
  return (
    useAuthStore((s) => {
      if (s.status === "loading") return undefined;
      return s.session.permissions;
    }) ?? EMPTY_PERMISSIONS
  );
};

export const useHasPermission = (
  name: Permission | Permission[],
  defaultValue = false,
): boolean => {
  return useAuthStore((s) => {
    if (s.status === "loading") return defaultValue;
    const permissions = s.session.permissions;
    if (typeof name === "string") {
      const reason = permissions[name];
      return reason ? reason === "GRANTED" : defaultValue;
    }
    return name.every((p) => {
      const reason = permissions[p];
      return reason ? reason === "GRANTED" : defaultValue;
    });
  });
};

export const useCanReopenAccount = (): boolean => {
  const reason = usePermission("reopenAccount");
  return reason === "GRANTED";
};
